import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge, List, Typography } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function ReportNoData() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const reports = (notifications || []).find(n => n.type === ENotificationType.REPORT_NO_DATA);
  if (!reports?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.REPORT_NO_DATA}`}>
      <List.Item extra={<Badge count={reports?.quantity || 0} showZero />}>
        <Typography.Text strong>Relatórios sem dados</Typography.Text>
      </List.Item>
    </Link>
  );
}
